import { useEffect } from 'react'

interface useInitCommentsProps {
  getRows: Function
  setRows: Function
  setDeleteEntryId: Function
  setShowModal: Function
  dependency: any
}

const useInit = (props: useInitCommentsProps) => {
  useEffect(() => {
    props
      .getRows({
        setDeleteEntryId: props.setDeleteEntryId,
        setShowModal: props.setShowModal,
      })
      .then((data: any) => {
        props.setRows(data)
      })
  }, [props.dependency])
}

export default useInit
